/*eslint-disable*/
import React from "react";
// reactstrap components
import { Container } from "reactstrap";
// core components
import { LazyLoadImage } from "react-lazy-load-image-component";
function IndexHeader() {
  let pageHeader = React.createRef();

  React.useEffect(() => {
    if (window.innerWidth > 991) {
      const updateScroll = () => {
        let windowScrollTop = window.pageYOffset / 3;
        pageHeader.current.style.transform =
          "translate3d(0," + windowScrollTop + "px,0)";
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  });

  return (
    <>
      <div id="Header-home" className="page-header clear-filter">
        <div
          className="page-header-image"
          style={{
            opacity: "0.7",
            backgroundImage:
              "url(" + require("assets/img/HASSSAN.jpg").default + ")",
          }}
          ref={pageHeader}
        ></div>
        <Container>
          <div className="content-center brand">
            <img
              className="img-Header"
              alt="..."
              src={require("assets/img/Logos.png").default}
            ></img>
          </div>
        </Container>
      </div>
    </>
  );
}

export default IndexHeader;
